import { UnityPlayerAPILoaderConfig, UnityPlayerAPIMessageInterface } from "../player-api/interfaces"

// @ts-nocheck
export const unityPlayerMethods = {
    sendMessage: (playerInstance: any, message: UnityPlayerAPIMessageInterface) => {
        //console.log("instance: ", playerInstance);

        playerInstance.SendMessage(message.gameObjectName, message.gameObjectMethodName, message.value)
    },
    quitPlayer: (playerInstance: any, onQuitCallback: Function) => playerInstance.Quit().then(onQuitCallback),
}

export const unity = {
    createUnityInstance: (canvas: HTMLElement, {
            dataUrl,
            frameworkUrl,
            codeUrl,
            streamingAssetsUrl,
            companyName,
            productName,
            productVersion,
            showBanner,
        // @ts-ignore
        }: UnityPlayerAPILoaderConfig, onProgress?: Function) => createUnityInstance(canvas, {
            dataUrl,
            frameworkUrl,
            codeUrl,
            streamingAssetsUrl,
            companyName,
            productName,
            productVersion,
            showBanner,
        }, onProgress),
}
